<template>

    <div class="row">
        <div class="col text-center">
            <div class="sau-bx bx-pad clearfix">
                <div class="row">
                    <div class="col">
                        <h4>Password</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col pt-2">
                        <p>This type of domain has one type of password within the Domain Management System: <span class="sau-font-bold">Access Password (and EPP Key / AuthInfo / Auth Code)</span> is used by
                        Domain Owners to login to the system and manage their own domain details and is used for domain transfers into and out of our system.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button v-if="canUpdateDomain" @click.prevent="sendAccessPassword()" class="btn bt-lg btn-success mx-auto" :disabled="submitting">Send Access Password <i v-if="submitting" class="far fa-spinner-third fa-spin"></i></button>
                        <p v-else>This functionality is not available on cancelled domains</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        props: ['domain'],
        data() {
            return {
                submitting: false,
            };
        },
        created() {
        },
        methods: {
            sendAccessPassword() {
                this.submitting = true;
                this.requestDomainAccessPassword().then(response => {
                    this.$swal({
                        type:'success',
                        text: response.data.message,
                        showConfirmButton: false,
                    });
                    this.submitting = false;
                }).catch(error => {
                     this.$swal({
                        type:'error',
                        title: 'Something went wrong',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.submitting = false;
                })
            }
        },
    }
</script>